<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12">
        <v-card>
          <v-card-title
            class="mx-3 px-0 mb-3"
            style="border-bottom: 2px solid #d7531f"
          >
            <v-col cols="12" md="6">
              <v-icon style="margin-right: 20px; color: #00294b" size="50">
                mdi-home-group
              </v-icon>
              Meus Imóveis
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="d-flex align-center justify-end pa-0"
            >
              <v-btn
                @click="
                  limpaImovel();
                  cadastroImovel = true;
                "
                class="StyleButton mt-0"
                >Adicionar novo imóvel</v-btn
              >
            </v-col>
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-model="selected"
              color="#ff770f"
              :loading="loadingImoveis"
              :headers="headers"
              :items="imoveis"
              item-key="id"
              :footer-props="{
                showFirstLastPage: true,
                itemsPerPageText: 'Por Página',
                pageText: 'Página',
              }"
            >
              <template v-slot:[`item.img`]="{ item }">
                <v-img
                  v-if="item.files.length == 0"
                  contain
                  width="150"
                  height="150"
                  src="../assets/gifSemFoto.gif"
                >
                </v-img>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      v-bind="attrs"
                      v-on="on"
                      @click="abrirImovel(item)"
                      color="#ff770f"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Imóvel</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      v-bind="attrs"
                      v-on="on"
                      text
                      color="#ff770f"
                      @click="excluirImovel(item.id)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Excluir Imóvel</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs">
                      <v-switch
                        :loading="imovel.loading"
                        color="#ff770f"
                        v-model="item.switch"
                        @change="
                          alteraStatusImovel(
                            item,
                            item.status === `AVAILABLE`
                              ? 'UNAVAILABLE'
                              : 'AVAILABLE'
                          )
                        "
                      ></v-switch>
                    </div>
                  </template>
                  <span>{{
                    item.status === `AVAILABLE`
                      ? `Desativar Imovel`
                      : `Ativar Imóvel`
                  }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.price`]="{ item }">
                <b>{{ item.price | cash }}</b>
                <p v-if="item.attributes[7]?.value === `true`">Vendido</p>
              </template>
              <template slot="progress">
                <v-progress-linear
                  indeterminate
                  color="#ff770fe0"
                ></v-progress-linear>
              </template>
              <template slot="loading"> Carregando imóveis </template>
              <template slot="no-data"> Nenhum imóvel encontrado. </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      v-model="cadastroImovel"
    >
      <v-card>
        <v-btn
          icon
          color="white"
          style="position: absolute; right: 15px; top: 15px"
          @click="cadastroImovel = false"
        >
          <v-icon color="black">mdi-close</v-icon>
        </v-btn>
        <v-container>
          <v-row>
            <v-col cols="12" class="mt-5 d-flex justify-center flex-column">
              <h1
                class="titleScope"
                style="
                  color: #ff770f;
                  font-size: 58px;
                  text-transform: uppercase;
                "
              >
                CADASTRE SEU IMÓVEL AQUI!
              </h1>
              <p class="textScope">
                Preencha as informações. Capriche nas fotos. Aguarde as
                propostas!
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <v-row>
                <v-col cols="12" md="12">
                  <p
                    class="textScope"
                    style="font-size: 18px; font-weight: bold"
                  >
                    Imóvel
                  </p>
                </v-col>
                <v-col cols="12" md="12">
                  <v-row>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="12" md="12">
                          <v-text-field
                            color="#ff770f"
                            label="Título"
                            prepend-inner-icon="mdi-text"
                            v-model="imovel.title"
                            placeholder=""
                            outlined
                          >
                          </v-text-field>
                        </v-col>

                        <v-col
                          style="padding: 0 12px !important"
                          cols="12"
                          md="6"
                        >
                          <label><small>Valor De</small></label>
                          <money
                            v-model="imovel.price"
                            v-bind="money"
                            color="#ff770f"
                            label="Valor De"
                            placeholder="Valor De"
                            outlined
                          >
                          </money>
                        </v-col>

                        <v-col
                          style="padding: 0 12px !important"
                          cols="12"
                          md="6"
                        >
                          <label><small>Valor Por</small></label>
                          <money
                            v-model="imovel.sale_price"
                            v-bind="money"
                            color="#ff770f"
                            label="Valor Por"
                            placeholder="Valor Por"
                            outlined
                          >
                          </money>
                        </v-col>
                        <v-col
                          align="center"
                          class="align-center justify-center d-flex"
                          cols="12"
                          md="6"
                        >
                          <h4>Aceita em ribus até</h4>
                        </v-col>
                        <v-col style="margin-top: 25px" cols="12" md="6">
                          <v-slider
                            min="5"
                            v-model="imovel.accepted_tokens_percentual"
                            step="5"
                            track-color="#ff770f70"
                            color="#ff770f"
                            thumb-color="#ff770f"
                            thumb-label="always"
                          ></v-slider>
                        </v-col>
                        <v-col
                          style="padding: 18px 12px 0 !important"
                          cols="12"
                          md="6"
                        >
                          <v-text-field
                            color="#ff770f"
                            label="IPTU"
                            placeholder=""
                            v-model="imovel.attributes[0].value"
                            outlined
                          ></v-text-field>
                        </v-col>

                        <v-col
                          style="padding: 0 12px !important"
                          cols="12"
                          md="6"
                        >
                          <label><small>Condomínio</small></label>
                          <money
                            v-bind="money1"
                            label="Condomínio"
                            placeholder=""
                            v-model="imovel.attributes[1].value"
                            outlined
                          >
                          </money>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row class="mt-5">
                    <v-col style="padding: 0 12px !important" cols="12" md="12">
                      <v-text-field
                        color="#ff770f"
                        prepend-inner-icon="mdi-image-text"
                        label="Descrição curta"
                        placeholder=""
                        v-model="imovel.short_description"
                        outlined
                      >
                      </v-text-field>
                    </v-col>

                    <v-col style="padding: 0 12px !important" cols="12" md="12">
                      <v-textarea
                        color="#ff770f"
                        name="input-7-1"
                        label="Descrição completa"
                        value=""
                        outlined
                        v-model="imovel.description"
                        prepend-inner-icon="mdi-text-box-multiple"
                        hint="Hint text"
                      >
                      </v-textarea>
                    </v-col>

                    <v-col style="padding: 0 12px !important" cols="12" md="12">
                      <v-checkbox
                        color="#ff770f"
                        v-model="imovel.attributes[7].value"
                        label="Imóvel vendido"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6">
              <v-row>
                <v-col cols="12">
                  <p
                    class="textScope"
                    style="font-size: 18px; font-weight: bold"
                  >
                    Informações
                  </p>
                </v-col>
                <v-col cols="12">
                  <v-select
                    prepend-inner-icon="mdi-home-city"
                    label="Tipo do Imóvel"
                    color="#ff770f"
                    :items="tipoImovel"
                    outlined
                    v-model="imovel.attributes[8].value"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Área (m²)"
                    color="#ff770f"
                    prepend-inner-icon="mdi-move-resize"
                    v-model="imovel.attributes[4].value"
                    placeholder=""
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Quartos"
                    prepend-inner-icon="mdi-bed"
                    color="#ff770f"
                    v-model="imovel.attributes[2].value"
                    placeholder=""
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Banheiros"
                    color="#ff770f"
                    prepend-inner-icon="mdi-toilet"
                    v-model="imovel.attributes[3].value"
                    placeholder=""
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Vagas"
                    prepend-inner-icon="mdi-car"
                    color="#ff770f"
                    v-model="imovel.attributes[5].value"
                    placeholder=""
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <p
                    class="textScope"
                    style="font-size: 18px; font-weight: bold"
                  >
                    Endereço
                  </p>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    color="#ff770f"
                    prepend-inner-icon="mdi-map-marker"
                    label="CEP"
                    placeholder="CEP"
                    v-model="imovel.attributes[6].value.zipcode"
                    @keyup="buscaCEP"
                    @blur="buscaCEP"
                    :append-icon="loadingCep ? 'mdi-loading' : ''"
                    outlined
                    v-mask="`########`"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    prepend-inner-icon="mdi-home"
                    color="#ff770f"
                    label="Logradouro"
                    placeholder="Logradouro"
                    v-model="imovel.attributes[6].value.street"
                    outlined
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="2">
                  <v-text-field
                    color="#ff770f"
                    prepend-inner-icon="mdi-numeric"
                    label="Número"
                    placeholder="Número"
                    v-model="imovel.attributes[6].value.number"
                    outlined
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    color="#ff770f"
                    prepend-inner-icon="mdi-city"
                    label="Complemento"
                    placeholder="Complemento"
                    v-model="imovel.attributes[6].value.complement"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    color="#ff770f"
                    prepend-inner-icon="mdi-home-group"
                    label="Bairro"
                    placeholder="Bairro"
                    v-model="imovel.attributes[6].value.district"
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    color="#ff770f"
                    prepend-inner-icon="mdi-home-city"
                    label="Cidade"
                    placeholder="Cidade"
                    v-model="imovel.attributes[6].value.city"
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    color="#ff770f"
                    prepend-inner-icon="mdi-sign-real-estate"
                    label="Estado"
                    placeholder="Estado"
                    v-model="imovel.attributes[6].value.state"
                    outlined
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <p class="textScope" style="font-size: 18px; font-weight: bold">
                Adicionar Imagens
              </p>
            </v-col>
            <v-col cols="12" md="12">
              <v-file-input
                v-model="files"
                multiple
                @change="enviarArquivo()"
                color="#ff770f"
                outlined
                accept="image/png, image/jpeg, image/jpg"
                chips
                prepend-icon="mdi-camera"
                placeholder="Selecione novas imagens para seu imóvel (.jpeg / .jpg / .png)"
              ></v-file-input>
            </v-col>
            <v-col cols="12" class="d-flex">
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                  v-for="(f, i) in filesUploaded"
                  :key="f.name"
                  align="center"
                >
                  <v-hover v-slot="{ hover }">
                    <v-card
                      :elevation="hover ? 12 : 2"
                      :class="{ 'on-hover': hover }"
                    >
                      <v-img :src="f" width="225px" contain height="225px">
                        <v-card-title class="text-h6 white--text fill-height">
                          <v-row
                            style="height: 100%"
                            class="d-flex fill-height flex-column justify-center align-center"
                          >
                            <v-btn
                              :class="{ 'show-btns': hover }"
                              :color="`rgba(255, 255, 255, 0)`"
                              icon
                              @click="removeImagem(filesUploaded, i)"
                            >
                              <v-icon
                                :class="{ 'show-btns-icons': hover }"
                                color="`rgba(255, 255, 255, 0)`"
                              >
                                mdi-delete
                              </v-icon>
                            </v-btn>
                          </v-row>
                        </v-card-title>
                      </v-img>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <p class="textScope" style="font-size: 18px; font-weight: bold">
                Galeria
              </p>
              <small>
                Clique e arraste as imagens abaixo para alterar a ordem,
                lembrando que a
                <span style="color: #ff770f"
                  >primeira é sempre a imagem destaque do produto</span
                >.
              </small>
            </v-col>
            <v-col cols="12">
              <draggable
                v-model="imovel.files"
                group="people"
                @start="drag = true"
                @end="drag = false"
                class="d-flex row"
              >
                <v-col
                  v-for="(img, i) in imovel.files"
                  :key="img.value"
                  cols="12"
                  :md="'3'"
                  class="d-flex justify-center"
                >
                  <v-hover v-slot="{ hover }">
                    <v-card
                      :elevation="hover ? 12 : 2"
                      :class="{ 'on-hover': hover }"
                    >
                      <v-img
                        v-if="img.url != undefined"
                        :src="img.url"
                        width="225px"
                        height="225px"
                      >
                        <v-card-title class="text-h6 white--text fill-height">
                          <v-row
                            class="d-flex fill-height flex-column justify-center align-center"
                          >
                            <v-btn
                              :disabled="loadingDelete[img.id]"
                              :class="{ 'show-btns': hover }"
                              :color="`rgba(255, 255, 255, 0)`"
                              icon
                              @click="excluirArquivo(img.id, i)"
                            >
                              <v-icon
                                v-if="!loadingDelete[img.id]"
                                :class="{ 'show-btns-icons': hover }"
                                color="`rgba(255, 255, 255, 0)`"
                              >
                                mdi-delete
                              </v-icon>
                              <v-progress-circular
                                v-if="loadingDelete[img.id]"
                                indeterminate
                                color="white"
                              ></v-progress-circular>
                            </v-btn>
                          </v-row>
                        </v-card-title>
                      </v-img>
                      <p v-if="i == 0" class="imgDestaque">Imagem Destaque</p>
                    </v-card>
                  </v-hover>
                </v-col>
              </draggable>
            </v-col>
            <v-col cols="12">
              <!-- <v-btn @click="editarArquivos()">Arquivos </v-btn> -->
              <v-btn
                v-if="imovel.id == undefined"
                style="margin-top: 20px"
                @click="adicionarImovel()"
                :loading="adicionando"
                class="StyleButton"
                block
                >Adicionar Imóvel</v-btn
              >
              <v-btn
                v-if="imovel.id != undefined"
                style="margin-top: 20px"
                @click="editarImovel()"
                :loading="adicionando"
                class="StyleButton"
                block
                >Salvar Imóvel</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import draggable from "vuedraggable";
import { Money } from "v-money";

export default {
  data() {
    return {
      cadastroImovel: false,
      drag: false,
      adicionando: false,
      loadingCep: false,
      loadingImoveis: false,
      checkbox2: "",
      valid: false,
      files: [],
      filesUploaded: [],
      selected: [],
      imagens: [],
      loadingDelete: [],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        // suffix: ' #',
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      money1: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        // suffix: ' #',
        precision: 2,
        masked: true /* doesn't work with directive */,
      },
      headers: [
        { text: "Ativo", value: "status", width: `80px` },
        {
          text: "Imagem",
          align: "start",
          sortable: false,
          width: `200px`,
          value: "img",
        },
        { text: "Titulo", value: "title", width: "350px" },
        { text: "Valor", value: "price" },
        { text: "Ações", value: "actions" },
      ],
      imoveis: [],
      imovel: {
        title: "",
        accepted_tokens_percentual: "5",
        type: "PROPERTY",
        display_order: 1,
        status: "AVAILABLE",
        short_description: "",
        description: "",
        attributes: [
          {
            name: "iptu",
            value: "",
          },
          {
            name: "condominio",
            value: "",
          },
          {
            name: "qtdeQuartos",
            value: "",
          },
          {
            name: "qtdeBanheiros",
            value: "",
          },
          {
            name: "qtdeVagas",
            value: "",
          },
          {
            name: "metragem",
            value: "",
          },
          {
            name: "address",
            value: {
              zipcode: "",
              street: "",
              number: "",
              complement: "",
              district: "",
              city: "",
              state: "",
            },
          },
          {
            name: "sold",
            value: false,
          },
          {
            name: "type",
            value: null,
          },
        ],
        files: [],
      },
      tipoImovel: [
        `Apartamento`,
        `Casa`,
        `Cobertura`,
        `Flat`,
        `Kitnet/Conjugado`,
        `Terreno`,
        `Lote Residencial`,
        `Lote Comercial`,
        `Fazenda`,
        `Sitio`,
        `Sala Comercial`,
        `Conjunto Comercial`,
        `Galpão`,
        `Depósito`,
        `Armazém`,
        `Edifício Comercial`,
        `Edíficio Residencial`,
      ],
    };
  },
  components: {
    draggable,
    Money,
  },
  mounted() {
    this.listarImoveis();
  },
  methods: {
    removeImagem(arr, i) {
      arr.splice(i, 1);
    },
    enviarArquivo() {
      //console.log(this.files);
      if (this.files !== null && this.files.length > 0) {
        this.loading = true;
        this.files.forEach((el, i) => {
          let formData = new FormData();

          formData.append("file", el);

          this.$http
            .post("/files/upload", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              if (response.data.status === "OK") {
                this.filesUploaded.push({
                  src: URL.createObjectURL(el),
                  name: response.data.result.fileName,
                  value: response.data.result.identifier,
                  display_order: this.imovel.files.length,
                });
                if (i === this.files.length - 1) {
                  this.files = [];
                }
                //this.salvarPerfil();
              } else {
                let text = response.data.result.message;
                this.$root.$emit("show-snack", { type: `error`, text: text });
              }
            })
            .catch((err) => {
              // console.log(err.response)
              let text = err.response.data.result.message;
              this.$root.$emit("show-snack", { type: `error`, text: text });
              if (i === this.files.length - 1) {
                this.files = [];
              }
            });
        });
      }
    },
    buscaCEP() {
      //Verifica se campo cep possui valor informado.
      if (this.imovel.attributes[6].value.zipcode != undefined) {
        var cep = this.imovel.attributes[6].value.zipcode.replace(/\D/g, "");

        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if (validacep.test(cep)) {
          this.loadingCep = true;
          fetch("https://viacep.com.br/ws/" + cep + "/json")
            .then((response) => response.json())
            .then((data) => {
              this.imovel.attributes[6].value.street = data.logradouro;
              this.imovel.attributes[6].value.district = data.bairro;
              this.imovel.attributes[6].value.city = data.localidade;
              this.imovel.attributes[6].value.state = data.uf;
              this.imovel.attributes[6].value.complement = data.complemento;
              // this.$forceUpdate();  // Notice we have to use a $ here
              this.loadingCep = false;
            });
        }
        return this.imovel.attributes[6].value.zipcode;
      }
      return this.imovel.attributes[6].value.zipcode;
    },
    listarImoveis() {
      this.loadingImoveis = true;
      this.$http.get("users/products?limit=100").then((res) => {
        this.imoveis = res.data.result.products;
        this.imoveis.forEach((el) => {
          el.switch = el.status === `AVAILABLE`;
          el.loading = false;
        });
        this.loadingImoveis = false;
      });
    },
    abrirImovel(item) {
      //window.console.log(item.attributes[6].value)
      //window.console.log(typeof item.attributes[6].value)
      if (typeof item.attributes[6].value == "string") {
        item.attributes[6].value = JSON.parse(item.attributes[6].value);
      }
      if (item.attributes[7] == undefined) {
        item.attributes[7] = { name: "sold", value: false };
      }
      if (item.attributes[8] == undefined) {
        item.attributes[8] = { name: "type", value: "no-type" };
      }
      item.attributes[7].value = item.attributes[7].value === `true`;

      this.imovel = { ...item };
      this.cadastroImovel = true;
    },
    limpaImovel() {
      this.imovel = {
        title: "",
        accepted_tokens_percentual: "5",
        type: "PROPERTY",
        display_order: 1,
        status: "AVAILABLE",
        short_description: "",
        description: "",
        attributes: [
          {
            name: "iptu",
            value: "",
          },
          {
            name: "condominio",
            value: "",
          },
          {
            name: "qtdeQuartos",
            value: "",
          },
          {
            name: "qtdeBanheiros",
            value: "",
          },
          {
            name: "qtdeVagas",
            value: "",
          },
          {
            name: "metragem",
            value: "",
          },
          {
            name: "address",
            value: {
              zipcode: "",
              street: "",
              number: "",
              complement: "",
              district: "",
              city: "",
              state: "",
            },
          },
          {
            name: "sold",
            value: false,
          },
          {
            name: "type",
            value: null,
          },
        ],
        files: [],
      };
    },
    adicionarImovel() {
      this.adicionando = true;
      if (typeof this.imovel.attributes[6].value == "object") {
        this.imovel.attributes[6].value = JSON.stringify(
          this.imovel.attributes[6].value
        );
      }
      this.imovel.attributes[7].value =
        this.imovel.attributes[7].value.toString();

      this.filesUploaded.forEach((el) => {
        this.imovel.files.push({
          name: el.name,
          value: el.value,
          display_order: el.display_order,
        });
      });
      this.filesUploaded = [];

      this.imovel.files.forEach((el, index) => {
        el.display_order = index;
      });
      this.$http
        .post("products", this.imovel)
        .then((res) => {
          if (res.data.status == "OK") {
            this.$root.$emit("show-snack", {
              type: `success`,
              text: `Imóvel adicionado com sucesso.`,
            });
            this.adicionando = false;
            this.listarImoveis();
            this.limpaImovel();
          } else {
            this.adicionando = false;
            let text = "";
            res.data.result.fields.forEach((el) => {
              if (el.message._required !== undefined) {
                text += el.message._required + "\r\n";
              } else {
                text += el.message + "\r\n";
              }
            });
            this.$root.$emit("show-snack", { type: `error`, text: text });
            this.imovel.attributes[6].value = JSON.parse(
              this.imovel.attributes[6].value
            );
          }
        })
        .catch((err) => {
          this.adicionando = false;
          let text = "";
          err.response.data.result.fields.forEach((el) => {
            if (el.message.name !== `attributes`) {
              text += el.message + " - ";
            } else {
              text += "Informações obrigatórias - ";
            }
          });
          this.$root.$emit("show-snack", { type: `error`, text: text });
          this.imovel.attributes[6].value = JSON.parse(
            this.imovel.attributes[6].value
          );
        });
    },
    editarImovel() {
      this.adicionando = true;
      if (typeof this.imovel.attributes[6].value == "object") {
        this.imovel.attributes[6].value = JSON.stringify(
          this.imovel.attributes[6].value
        );
      }
      this.imovel.attributes[7].value =
        this.imovel.attributes[7].value.toString();

      this.filesUploaded.forEach((el) => {
        this.imovel.files.push({
          name: el.name,
          value: el.value,
          display_order: el.display_order,
        });
      });
      this.filesUploaded = [];

      this.salvarArquivos();

      this.$http
        .put("products/" + this.imovel.id, this.imovel)
        .then((res) => {
          if (res.data.status == "OK") {
            this.$root.$emit("show-snack", {
              type: `success`,
              text: `Imóvel salvo com sucesso.`,
            });
            this.cadastroImovel = false;
            this.adicionando = false;
            this.imovel.attributes[6].value = JSON.parse(
              this.imovel.attributes[6].value
            );
            this.listarImoveis();
          }
        })
        .catch((err) => {
          this.adicionando = false;
          let text = "";
          err.response.data.result.fields.forEach((el) => {
            if (el.message.name !== `attributes`) {
              text += el.message + " - ";
            } else {
              text += "Informações obrigatórias - ";
            }
          });
          this.$root.$emit("show-snack", { type: `error`, text: text });
        });
    },
    excluirArquivo(id, index) {
      this.loadingDelete[id] = true;
      this.$http.delete("products/file/" + id).then((res) => {
        if (res.data.status == "OK") {
          this.imovel.files.splice(index, 1);
          this.loadingDelete[id] = false;
        }
      });
    },
    excluirImovel(id) {
      if (confirm(`Tem certeza que deseja remover este imóvel? `)) {
        this.$http.delete("products/" + id).then((res) => {
          if (res.data.status == "OK") {
            this.listarImoveis();
            this.$root.$emit("show-snack", {
              type: `success`,
              text: `Imóvel removido com sucesso.`,
            });
          }
        });
      }
    },
    salvarArquivos() {
      let tmpFiles = [];
      this.imovel.files.forEach((el, index) => {
        tmpFiles.push({
          id: el.id,
          display_order: index,
        });
      });
      this.$http
        .put("products/" + this.imovel.id + "/files", { files: tmpFiles })
        .then((res) => {
          if (res.data.status == "OK") {
            this.listarImoveis();
          }
        });
    },
    alteraStatusImovel(imovel, status) {
      imovel.status = status;
      imovel.loading = true;
      this.$http
        .put("products/" + imovel.id, imovel)
        .then((res) => {
          if (res.data.status == "OK") {
            this.$root.$emit("show-snack", {
              type: `success`,
              text: `Imóvel ${imovel.title} ${
                status === `AVAILABLE` ? `ATIVADO` : `DESATIVADO `
              } com sucesso.`,
            });
          } else {
            this.$root.$emit("show-snack", {
              type: `error`,
              text: `Erro ao alterar status do imóvel.`,
            });
          }
          imovel.loading = false;
        })
        .catch(() => {
          this.$root.$emit("show-snack", {
            type: `error`,
            text: `Erro ao alterar status do imóvel.`,
          });

          imovel.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.v-money {
  padding: 13px;
  border: 1px solid gray;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 15px;
}
.v-money:focus {
  border-color: red !important;
}
.v-money::placeholder {
  display: block;
}
.imgDestaque {
  text-align: center;
  background-color: #00294b;
  color: white;
  margin-bottom: 0px;
  font-weight: bold;
}
.v-card {
  transition: opacity 0.4s ease-in-out;
}

.v-card:not(.on-hover) {
  opacity: 1;
}

.v-card .on-hover {
  opacity: 0.9;
}

.show-btns-icons {
  color: rgba(255, 255, 255, 1) !important;
}

.show-btns {
  background-color: rgba(255, 0, 0, 0.7) !important;
}

@media (min-device-width: 300px) and (max-device-width: 819px) {
  .paddigMobile {
    padding: 0px 10px !important;
  }

  .padMobile {
    padding: 20px 60px !important;
  }
}

.StyleButton {
  background-color: #ff770fe0 !important;
  color: #fff !important;
  font-family: "Poppins";
  border-radius: 50px;
  margin-top: 20px;
}

.titleCarrocel {
  font-size: 28px;
  font-family: "Poppins";
  font-weight: 500;
  color: #fff;
  text-align: left;
}

.titleScope {
  font-size: 32px;
  font-family: "Poppins";
  line-height: 1;
  font-weight: 800;
  text-align: left;
}

.textScopeDepoiments {
  margin-bottom: 0px;
  font-size: 15px;
  font-family: "Poppins";
  font-weight: 300;
  text-align: left;
}

.textScope {
  margin-bottom: 0px;
  font-size: 20px;
  font-family: "Poppins";
  font-weight: 300;
  text-align: left;
}
</style>
